<ng-container *ngIf="isVisible">

  <a *ngIf="variant === 'menu-item'" class="dropdown-item theme-switch-item" href="javascript: void(0);" (click)="toggle()">
    <i class="{{ icon }} font-size-16 align-middle me-1"></i>
    {{ label }}
    <span class="badge bg-warning ms-2" *ngIf="!isModern">Yeni</span>
  </a>

  <button *ngIf="variant === 'button'" type="button" class="btn btn-sm btn-outline-secondary theme-switch-button" (click)="toggle()">
    <i class="{{ icon }} align-middle me-1"></i>
    {{ label }}
  </button>

</ng-container>
